<template>
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.HealthyCheck.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.HealthyCheck.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.HealthyCheck.msg3') }}</div>
      </div>
      <div class="layer__body">
        <span class="img-area"><img src="@/assets/images/common/artwork_idle_check_3d.gif"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'healthyCheck',
  data() {
    return {};
  },
  props: {
    imgPath : String
  },
  methods: {},
};
</script>

<style src='@/assets/css/user/common.css' scoped></style>
<style scoped>
</style>
